import { render, staticRenderFns } from "./OverlayOpenIcon.vue?vue&type=template&id=54cb8236&"
import script from "./OverlayOpenIcon.vue?vue&type=script&lang=js&"
export * from "./OverlayOpenIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports